import { gql } from '@apollo/client';

export const CREATE_OR_UPDATE_QUOTE = gql`
  mutation UpdateQuote($input: UpdateQuoteInput!) {
    quote {
      result: updateQuote(input: $input) {
        error
        success
        entity {
          vendorOpportunityId
        }
      }
    }
  }
`;
